import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import axios from "axios";
import cookies from "vue-cookies";
import Swal from "sweetalert2";
import _ from "lodash";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // web
    loading: false,
    button_loading: false,
    error: false,
    error_msg: null,
    keyboardmenu: true,
    drawer: { state: null },
    toggle_formconfig: { toggle: false },
    interval: {},
    // auth
    token: cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token"),
    username: null,
    password: null,
    logged: false,
    expire: false,
    // survey
    surveylist: [],
    diagram: [],
    surveystatus: false,
    // question
    editing: false,
    editingPreData: null,
    editingConfirm: { edit: false },
    editingCurrent: null,
    texttoadd: { text: null },
    mockquestion: [],
    operation: [
      { text: "มากกว่า", operation: ">" },
      { text: "น้อยกว่า", operation: "<" },
      { text: "มากกว่าเท่ากับ", operation: ">=" },
      { text: "น้อยกว่าเท่ากับ", operation: "<=" },
      { text: "อยู่ระหว่าง", operation: "><" },
      { text: "ไม่อยู่ระหว่าง", operation: "<>" },
      { text: "เท่ากับ", operation: "==" },
      { text: "ไม่เท่ากับ", operation: "!=" },
    ],
    allquestion: [],
    allquestioninfo: [],
    tempcondition: { conditiontype: null, condition: [] },
    // webform
    firstquestion: null,
    surveyInfoNoCookie: {
      surveyName: "",
      surveyDetail: "",
    },
    // role
    rolelist: [],
    permissionlist: [],
    user_permission: {
      limitSurvey: 1,
      survey: {
        enableControl: false,
        create: false,
        update: false,
        delete: false,
      },
      question: {
        create: false,
        update: false,
        delete: false,
      },
      report: {
        view: false,
        download: false,
      },
      account: {
        view: false,
        update: false,
        delete: false,
        createInvite: false,
        createRole: false,
      },
    },
  },
  mutations: {
    Login(state, token) {
      state.token = token;
      state.logged = true;
      state.expire = false;
      cookies.set(process.env.VUE_APP_CM_AUTH_COOKIE + "_token", token);
    },
    Logout(state) {
      state.logged = false;
      state.loading = false;
      state.button_loading = false;
      state.expire = true;
      state.token = null;
      state.editing = false;
      state.editingPreData = null;
      state.editingConfirm = { edit: false };
      state.editingCurrent = null;
      state.surveylist = [];
      cookies.remove(process.env.VUE_APP_CM_AUTH_COOKIE + "_token");
      cookies.remove(process.env.VUE_APP_CM_AUTH_COOKIE + "_username");
      clearInterval(state.interval);
      state.interval = {};
    },
    ToggleLoading(state) {
      state.loading = !state.loading;
    },
    ToggleButtonLoading(state) {
      state.button_loading = !state.button_loading;
    },
    ToggleEditing(state) {
      state.editing = !state.editing;
    },
    KeyboardMenuToggle(state) {
      state.keyboardmenu = !state.keyboardmenu;
    },
    KeyboardMenuOff(state) {
      state.keyboardmenu = false;
    },
    UpdateSurvey(state, surveylist) {
      state.surveylist = [...surveylist];
    },
    UpdateQuestion(state, allquestion) {
      state.allquestion = [...allquestion];
    },
    UpdateQuestionPreEditing(state, question) {
      // console.log('questionPreLabel store', question.questionLabel);
      // console.log('--------------');
      state.editingPreData = question;
    },
    AddQuestion(state, question) {
      state.allquestion.push(question);
    },
    UpdateQuestionInfo(state, allquestioninfo) {
      state.allquestion = [...allquestioninfo];
    },
    AddQuestionInfo(state, questioninfo) {
      state.allquestioninfo.push(questioninfo);
    },
    setFirstquestion(state, questioninfo) {
      state.firstquestion = questioninfo;
    },
    UpdateRolelist(state, request) {
      state.rolelist = request;
    },
    UpdatePermissionlist(state, permission) {
      state.permissionlist = permission;
    },
    UpdateUserPermission(state, user_permission) {
      // console.log(user_permission);
      if (user_permission.permission) {
        if (Object.keys(user_permission.permission).length > 0) {
          state.user_permission = user_permission.permission;
        } else {
          state.user_permission = {
            limitSurvey: 1,
            survey: {
              enableControl: false,
              create: false,
              update: false,
              delete: false,
            },
            question: {
              create: false,
              update: false,
              delete: false,
            },
            report: {
              view: false,
              download: false,
            },
            account: {
              view: false,
              update: false,
              delete: false,
              createInvite: false,
              createRole: false,
            },
          };
        }
      } else {
        state.user_permission = {
          limitSurvey: 1,
          survey: {
            enableControl: false,
            create: false,
            update: false,
            delete: false,
          },
          question: {
            create: false,
            update: false,
            delete: false,
          },
          report: {
            view: false,
            download: false,
          },
          account: {
            view: false,
            update: false,
            delete: false,
            createInvite: false,
            createRole: false,
          },
        };
      }
    },
    BacktoEditing(state) {
      let elementsInErrors = document.getElementsByClassName("error--text");
      // console.log(
      //   document.querySelectorAll(`#${state.editingPreData.questionID} `)
      // );
      if (elementsInErrors && elementsInErrors.length > 1) {
        let question = state.allquestion.find(
          (q) => q.questionID === state.editingPreData.questionID
        );
        if (question) {
          question.editable = !question.editable;
          question.editable = !question.editable;
        }
        elementsInErrors[0].scrollIntoView(true);
        let scrolledY = window.scrollY;
        if (scrolledY) {
          window.scroll(0, scrolledY - 90);
        }
      } else {
        let access = document.getElementById(state.editingPreData.questionID);
        access.scrollIntoView(true);
        let scrolledY = window.scrollY;
        if (scrolledY) {
          let question = state.allquestion.find(
            (q) => q.questionID === state.editingPreData.questionID
          );
          if (question) {
            question.editable = !question.editable;
            question.editable = !question.editable;
          }
          window.scroll(0, scrolledY - 64);
        }
      }
    },
  },
  actions: {
    // trial & permission
    async getTrial({ commit, getters }) {
      // console.log("-------- getTrial --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey/trial`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      let success = response.status === 200;
      if (success && !router.currentRoute.params.surveyID) {
        commit("UpdateUserPermission", response.data);
      }
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response) : reject(response);
      });
    },
    async getQuestionPermission({ dispatch, commit, getters }, surveyID) {
      // console.log("-------- getSurvey --------");
      commit("ToggleLoading");
      let checkPackage = await dispatch("checkPackage");
      let response;
      if (checkPackage) {
        let api = {
          method: "get",
          url: `${process.env.VUE_APP_API}/manageSurvey/permission/${surveyID}`,
          data: {},
        };
        response = await getters.SendAPIWithHeader(api);
      }
      // console.log("manageSurvey/permission", response.data);
      let success = response.status === 200;
      if (success) {
        commit("UpdateUserPermission", response.data);
      }
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response) : reject(response);
      });
    },
    async Trial({ commit, getters }) {
      // console.log("-------- getSurvey --------");
      commit("ToggleLoading");
      let api = {
        method: "post",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey/trial`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response) : reject(response);
      });
    },
    // survey
    async AddPrequestion({ commit, getters }, items) {
      // console.log("-------- AddPrequestion --------");
      commit("ToggleLoading");
      let qid;
      // end
      // console.log('end')
      for (let index = 0; index < items.end; index++) {
        let data = {
          questionLabel: "จบคำถามรูปแบบที่ " + (index + 1),
          questionType: "end",
          indexing: index,
          questions: [
            {
              type: "text",
              payload: {
                text: "จบคำถามรูปแบบที่ " + (index + 1),
              },
            },
          ],
        };
        let api = {
          method: "post",
          url: `${process.env.VUE_APP_API}/manageSurvey/survey/${items.surveyID}/question`,
          data: data,
        };
        let response = await getters.SendAPIWithHeader(api);
        // console.log(response)
        let success = response.status === 200;
        if (!success) {
          commit("ToggleLoading");
          return Promise.reject(response);
        } else {
          if (index === 0) {
            qid = response.data.questionID;
            // console.log(qid)
          }
        }
      }
      // connect
      // console.log('connect')
      for (let index = items.connect - 1; index >= 0; index--) {
        let data = {
          questionLabel: "คำถามที่ " + (+index + 1),
          questionType: +index === 0 ? "start" : "connect",
          indexing: +index,
          questions: [
            {
              type: "text",
              payload: {
                text: "คำถามที่ " + (+index + 1),
              },
            },
          ],
          conditionType: "freetext",
          conditionsAnswer: {
            match: [
              {
                nextQuestionID: qid,
                score: {},
                value: 0,
              },
            ],
            notmatch: {
              nextQuestionID: qid,
              score: 0,
            },
            failCaseID: null,
          },
        };
        let api = {
          method: "post",
          url: `${process.env.VUE_APP_API}/manageSurvey/survey/${items.surveyID}/question`,
          data: data,
        };
        let response = await getters.SendAPIWithHeader(api);
        // console.log(response)
        let success = response.status === 200;
        if (!success) {
          commit("ToggleLoading");
          return Promise.reject(response);
        } else {
          qid = response.data.questionID;
          // console.log(qid)
        }
      }
      // fail
      // console.log('fail')
      for (let index = 0; index < items.fail; index++) {
        let data = {
          questionLabel: "ตอบคำถามผิดพลาด",
          questionType: "fail",
          indexing: 2,
          questions: [
            {
              type: "text",
              payload: {
                text: "ตอบคำถามผิดพลาด",
              },
            },
          ],
        };
        let api = {
          method: "post",
          url: `${process.env.VUE_APP_API}/manageSurvey/survey/${items.surveyID}/question`,
          data: data,
        };
        let response = await getters.SendAPIWithHeader(api);
        // console.log(response)
        let success = response.status === 200;
        if (!success) {
          commit("ToggleLoading");
          return Promise.reject(response);
        }
      }
      commit("ToggleLoading");
      return 200;
    },
    async MultiCopyQuestion({ commit, getters }, question) {
      // console.log("-------- MultiCopyQuestion --------");
      commit("ToggleLoading");
      let qid = null;
      // copy
      let adjustq = [];
      for (let index = question.copy - 1; index >= 0; index--) {
        let q = JSON.parse(JSON.stringify(question.data));
        q.indexing = q.indexing + +index;
        q.questionLabel = q.questionLabel + "_" + (index + 1);
        if (question.auto) {
          q.conditionsAnswer.match.map((nq) => {
            if (index === question.copy - 1) {
              nq.nextQuestionID = question.endID;
            } else {
              nq.nextQuestionID = qid;
            }
          });
        }
        let api = {
          method: "post",
          url: `${process.env.VUE_APP_API}/manageSurvey/survey/${router.currentRoute.params.surveyID}/question`,
          data: q,
        };
        let response = await getters.SendAPIWithHeader(api);
        // console.log(response)
        let success = response.status === 200;
        if (!success) {
          commit("ToggleLoading");
          return Promise.reject(response);
        } else {
          q.questionID = response.data.questionID;
          adjustq.push(q);
          qid = response.data.questionID;
          // console.log(qid)
        }
      }
      commit("ToggleLoading");
      return adjustq;
    },
    async getSurvey({ dispatch, commit, getters }) {
      // console.log("-------- getSurvey --------");
      commit("ToggleLoading");
      let checkPackage = await dispatch("checkPackage");
      let response;
      if (checkPackage) {
        let api = {
          method: "get",
          url: `${process.env.VUE_APP_API}/manageSurvey/survey`,
          data: {},
        };
        response = await getters.SendAPIWithHeader(api);
      }
      // console.log(response);
      let success = response.status === 200;
      if (success) {
        commit("UpdateSurvey", response.data);
      }
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject();
      });
    },
    async getSurveyByID({ getters, state }, surveyID) {
      // console.log("-------- getSurveyByID --------");
      // console.log(surveyID);
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey/${surveyID}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success =
        response.status === 200 && Object.keys(response.data).length > 0;
      if (success) {
        state.surveystatus = response.data.surveyStatus;
      }
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response) : reject(response);
      });
    },
    async CopySurvey({ commit, getters }, surveyID) {
      // console.log("-------- getSurvey --------");
      commit("ToggleLoading");
      let api = {
        method: "post",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey/duplicate`,
        data: {
          surveyID: surveyID,
        },
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response) : reject(response);
      });
    },
    async UpdateSurvey({ commit, getters }, survey) {
      // console.log('-------- UpdateSurvey --------')
      commit("ToggleLoading");
      let api = {
        method: "put",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey`,
        data: survey,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject(response);
      });
    },
    async UpdateSurveyStatus({ commit, getters }, survey) {
      // console.log('-------- UpdateSurveyStatus --------')
      commit("ToggleLoading");
      let api = {
        method: "put",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey/status`,
        data: survey,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject(response);
      });
    },
    async AddSurvey({ commit, getters }, survey) {
      // console.log('-------- AddSurvey --------')
      commit("ToggleLoading");
      let api = {
        method: "post",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey`,
        data: survey,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response);
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject(response);
      });
    },
    async DeleteSurvey({ commit, getters }, survey) {
      // console.log('-------- DeleteSurvey --------')
      commit("ToggleLoading");
      let api = {
        method: "delete",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey`,
        data: survey,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject(response);
      });
    },
    // question
    async getQuestionLabel({ commit, getters }, survey) {
      // console.log("-------- getQuestionLabel --------");
      commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey/${survey.surveyID}/question`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      if (success) {
        commit("UpdateQuestion", response.data);
      }

      // let allquestion = getters.QuestionLabel(survey.surveyID);
      // commit("UpdateQuestion", allquestion);
      commit("ToggleLoading");
      // return { survey: survey, prequestion: allquestion.length === 0 };
      return { survey: survey, prequestion: response.data.length === 0 };
    },
    async AddQuestionLabel({ commit, getters }, question) {
      // console.log("-------- AddQuestionLabel --------");
      commit("ToggleLoading");
      let api = {
        method: "post",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey/${router.currentRoute.params.surveyID}/question`,
        data: question,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response) : reject(response);
      });
    },
    async UpdateQuestionIndex({ commit, getters }, question) {
      // console.log("-------- UpdateQuestionLabel --------");
      commit("ToggleLoading");
      let api = {
        method: "put",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey/${router.currentRoute.params.surveyID}/question/${question.questionID}/index`,
        data: {
          questionType: question.questionType,
          indexing: question.indexing,
        },
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject();
      });
    },
    async DeleteQuestionLabel({ commit, getters }, questionID) {
      // console.log("-------- DeleteQuestionLabel --------");
      commit("ToggleLoading");
      let api = {
        method: "delete",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey/${router.currentRoute.params.surveyID}/question`,
        data: questionID,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response) : reject(response);
      });
    },
    async getQuestionInfo({ commit, getters }, questionID) {
      // console.log("-------- getQuestionInfo --------");
      if (questionID) {
        commit("ToggleLoading");
        let api = {
          method: "get",
          url: `${process.env.VUE_APP_API}/manageSurvey/survey/${router.currentRoute.params.surveyID}/question/questioninfo/${questionID}`,
          data: {},
        };
        let response = await getters.SendAPIWithHeader(api);
        // console.log(response)
        let success = response.status === 200;
        commit("ToggleLoading");
        return new Promise((resolve, reject) => {
          return success ? resolve(response.data) : reject(response);
        });
      }
    },
    async getQuestionInfoDel({ getters }, questionID) {
      // console.log("-------- getQuestionInfo --------");
      if (questionID) {
        let api = {
          method: "get",
          url: `${process.env.VUE_APP_API}/manageSurvey/survey/${router.currentRoute.params.surveyID}/question/questioninfo/${questionID}`,
          data: {},
        };
        let response = await getters.SendAPIWithHeader(api);
        // console.log(response)
        let success = response.status === 200;
        return new Promise((resolve, reject) => {
          return success ? resolve(response.data) : reject(response);
        });
      }
    },
    async UpdateQuestionInfo({ commit, getters }, question) {
      // console.log("-------- UpdateQuestionInfo --------");
      commit("ToggleLoading");
      let api = {
        method: "put",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey/${router.currentRoute.params.surveyID}/question/${question.questionID}`,
        data: question,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response) : reject(response);
      });
    },
    async QuestionIndexMoving({ commit, getters }, question) {
      // console.log("-------- QuestionIndexMoving --------");
      commit("ToggleLoading");
      let api = {
        method: "post",
        url: `${process.env.VUE_APP_API}/manageSurvey/survey/${router.currentRoute.params.surveyID}/question/indexing`,
        data: question,
      };
      let response = await getters.SendAPIWithHeader(api);

      // console.log(result)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response) : reject(response);
      });
      // return response
    },
    async CheckHaveAnswer({ commit, getters }, data) {
      // console.log("-------- QuestionIndexMoving --------");
      commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/manageSurvey/checkHaveAnswer/${data.surveyID}/${data.questionID}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response) : reject(response);
      });
      // return response
    },
    // own request api
    async UploadFormData({ getters }, formData) {
      // console.log("-------- UploadFormData --------");
      // commit("ToggleLoading")
      let picsize = formData.get("fileData").size;
      let maxsize = formData.get("fileMax");
      if (picsize / 1000000 < maxsize) {
        let api = {
          method: "post",
          url:
            process.env.VUE_APP_API_DOMAIN + "/CMStorage/uploadContentFromData",
          data: formData,
        };
        let response = await getters.SendAPIWithFormData(api);
        let success = response.status === 200;

        return new Promise((resolve, reject) => {
          return success ? resolve(response) : reject(response);
        });
      } else {
        Swal.fire({
          icon: "error",
          text: "กรุณา upload ไฟล์ไม่เกิน " + maxsize + " mb",
          showCancelButton: false,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          confirmButtonColor: "#0093cc",
          confirmButtonText: "ตกลง",
        });
        return new Promise((resolve, reject) => {
          return reject();
        });
      }
    },
    async CheckPermission({ getters }) {
      // console.log("-------- CheckPermission --------");
      // commit("ToggleLoading")
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/manageSurvey/permission/${router.currentRoute.params.surveyID}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response) : reject(response);
      });
    },
    // role
    async getInviteURL({ commit, getters }, data) {
      // console.log("-------- getSurvey --------");
      commit("ToggleLoading");
      let api = {
        method: "post",
        url: `${process.env.VUE_APP_API_DOMAIN}/CMUser/manageInvite/generate`,
        data: data,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response.data)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response) : reject(response);
      });
    },
    async getRole({ commit, getters }) {
      // console.log("-------- getSurvey --------");
      commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/manageAccount/member/${router.currentRoute.params.surveyID}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response.data);
      let success = response.status === 200;
      if (success) {
        commit("UpdateRolelist", response.data);
      }
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject();
      });
    },
    async UpdateRole({ commit, getters }, role) {
      // console.log('-------- UpdateSurvey --------')
      commit("ToggleLoading");
      let api = {
        method: "put",
        url: `${process.env.VUE_APP_API}/manageAccount/member`,
        data: role,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject(response);
      });
    },
    async DeleteRole({ commit, getters }, role) {
      // console.log('-------- DeleteRole --------')
      commit("ToggleLoading");
      let api = {
        method: "delete",
        url: `${process.env.VUE_APP_API}/manageAccount/member`,
        data: role,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject(response);
      });
    },
    async ReqestSurvey({ commit, getters }, request) {
      // console.log("-------- getSurvey --------");
      commit("ToggleLoading");
      let api = {
        method: "post",
        url: `${process.env.VUE_APP_API}/manageSurvey/permission`,
        data: request,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject(response);
      });
    },
    // permission
    async checkPackage({ commit, getters }) {
      // console.log("-------- getSurvey --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API_DOMAIN}/CMSurvey/v3/manageAccount/checkPackage`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response.data)
      let success = response.status === 200;
      // commit("ToggleLoading");
      if (success) {
        if (response.data.typeUser === "ExpiredUser") {
          Swal.fire({
            html: `Package ของคุณหมดอายุ<br>กรุณาติดต่อทีมงานเพื่อขอต่ออายุบริการได้ที่<br><a style="color: #0093cc;"
              href='tel:0935781416'
              >093-5781416</a
            >, <a style="color: #0093cc;"
            href='tel:0655214474'
            >065-5214474</a
          >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          >`,
            icon: "warning",
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            confirmButtonColor: "#0093cc",
            confirmButtonText: "ตกลง",
          }).then(() => {
            commit("Logout");
          });
        } else if (response.data.typeUser === "NotStartUser") {
          Swal.fire({
            html: `บัญชีของคุณยังไม่สามารถใช้งานได้ จะสามารถใช้งานได้ตั้งแต่วันที่ ${getters.dateConvertVeryShort(
              response.data.startedDate
            )} เป็นต้นไป<br>สอบถามข้อมูลเพิ่มเติมได้ที่<br><a style="color: #0093cc;"
                href='tel:0935781416'
                >093-5781416</a
              >, <a style="color: #0093cc;"
              href='tel:0655214474'
              >065-5214474</a
            >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          >`,
            icon: "warning",
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            confirmButtonColor: "#0093cc",
            confirmButtonText: "ตกลง",
          }).then(() => {
            commit("Logout");
          });
        } else {
          return new Promise((resolve, reject) => {
            return success ? resolve(response) : reject(response);
          });
        }
      } else {
        if (response.data.message === "Failed to authenticate token.") {
          commit("Logout");
        } else if (response.data.message === "Token not match.") {
          commit("Logout");
          Swal.fire({
            html: `พบการ login ซ้ำ`,
            icon: "warning",
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            confirmButtonColor: "#0093cc",
            confirmButtonText: "รับทราบ",
          });
        } else {
          Swal.fire({
            html: `ไม่สามารถตรวจสอบ package ที่คุณใช้ได้<br>สอบถามข้อมูลเพิ่มเติมได้ที่<br><a style="color: #0093cc;"
                href='tel:0935781416'
                >093-5781416</a
              >, <a style="color: #0093cc;"
              href='tel:0655214474'
              >065-5214474</a
            >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          >`,
            icon: "warning",
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            confirmButtonColor: "#0093cc",
            confirmButtonText: "ตกลง",
          }).then(() => {
            commit("Logout");
          });
        }
      }
    },
    async getPermission({ commit, getters }) {
      // console.log("-------- getPermission --------");
      commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/manageAccount/role/${router.currentRoute.params.surveyID}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response.data)
      let success = response.status === 200;
      if (success) {
        commit("UpdatePermissionlist", response.data);
      }
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject();
      });
    },
    async CreatePermission({ commit, getters }, permission) {
      // console.log('-------- UpdateSurvey --------')
      commit("ToggleLoading");
      let api = {
        method: "post",
        url: `${process.env.VUE_APP_API}/manageAccount/role`,
        data: permission,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject(response);
      });
    },
    async UpdatePermission({ commit, getters }, permission) {
      // console.log('-------- UpdateSurvey --------')
      commit("ToggleLoading");
      let api = {
        method: "put",
        url: `${process.env.VUE_APP_API}/manageAccount/role`,
        data: permission,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject(response);
      });
    },
    async DeletePermission({ commit, getters }, permission) {
      // console.log('-------- DeletePermission --------')
      commit("ToggleLoading");
      let api = {
        method: "delete",
        url: `${process.env.VUE_APP_API}/manageAccount/role`,
        data: permission,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve() : reject(response);
      });
    },
    // Dashboard overview
    async DashboardGeneral({ getters }) {
      // console.log("-------- DashboardGeneral --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/dashboard/${router.currentRoute.params.surveyID}/general`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async DashboardSocialSummaryPie({ getters }, daterange) {
      // console.log("-------- DashboardSocialSummaryPie --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/dashboard/${router.currentRoute.params.surveyID}/socialsummary/piechart/${daterange[0]}/${daterange[1]}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async DashboardSocialSummaryBasic({ getters }, daterange) {
      // console.log("-------- DashboardSocialSummaryBasic --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/dashboard/${router.currentRoute.params.surveyID}/socialsummary/basicchart/${daterange[0]}/${daterange[1]}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async DashboardUserHeatmap({ getters }, data) {
      // console.log("-------- DashboardUserHeatmap --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/dashboard/${router.currentRoute.params.surveyID}/heatmap/${data.social}/${data.daterange[0]}/${data.daterange[1]}/4`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async DashboardSummaryScore({ getters }, data) {
      // console.log("-------- DashboardSummaryScore --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/dashboard/${router.currentRoute.params.surveyID}/summaryscore/${data.social}/${data.daterange[0]}/${data.daterange[1]}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async DashboardBoxplotScore({ getters }, data) {
      // console.log("-------- DashboardBoxplotScore --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/dashboard/${router.currentRoute.params.surveyID}/boxplot/${data.social}/${data.daterange[0]}/${data.daterange[1]}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async DashboardReport({ getters }, data) {
      // console.log("-------- DashboardBoxplotScore --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/dashboard/${router.currentRoute.params.surveyID}/datatable/${data.social}/${data.daterange[0]}/${data.daterange[1]}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    // Dashboard question
    async DashboardGetFreetextChart({ getters }, data) {
      // console.log("-------- DashboardGetFreetextChart --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/dashboard/${router.currentRoute.params.surveyID}/freetext/${data.questionID}/${data.typechart}/${data.social}/${data.daterange[0]}/${data.daterange[1]}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async DashboardGetFixtextChart({ getters }, data) {
      // console.log("-------- DashboardGetFixtextChart --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/dashboard/${router.currentRoute.params.surveyID}/fixtext/${data.questionID}/${data.typechart}/${data.social}/${data.daterange[0]}/${data.daterange[1]}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async DashboardGetNumberInfo({ getters }, data) {
      // console.log("-------- DashboardGetNumberChart --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/dashboard/${router.currentRoute.params.surveyID}/number/${data.questionID}/info/${data.social}/${data.daterange[0]}/${data.daterange[1]}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async DashboardGetNumberChart({ getters }, data) {
      // console.log("-------- DashboardGetNumberChart --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/dashboard/${router.currentRoute.params.surveyID}/number/${data.questionID}/${data.typechart}/${data.social}/${data.daterange[0]}/${data.daterange[1]}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async DashboardGetMultiselectChart({ getters }, data) {
      // console.log("-------- DashboardGetMultiselectChart --------");
      // commit("ToggleLoading");
      let api = {
        method: "get",
        url: `${process.env.VUE_APP_API}/dashboard/${router.currentRoute.params.surveyID}/multiselect/${data.questionID}/${data.typechart}/${data.social}/${data.daterange[0]}/${data.daterange[1]}`,
        data: {},
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      // commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    // webform
    async CheckboxGroup({ commit, getters }, data) {
      // console.log("-------- getQuestionInfo --------");
      if (data.questionID) {
        commit("ToggleLoading");
        let api = {
          method: "get",
          url: `${process.env.VUE_APP_API}/manageSurvey/survey/${data.surveyID}/question/questioninfo/${data.questionID}`,
          data: {},
        };
        let response = await getters.SendAPIWithHeader(api);
        // console.log(response)
        let success = response.status === 200;
        commit("ToggleLoading");
        return new Promise((resolve, reject) => {
          return success ? resolve(response.data) : reject(response);
        });
      }
    },
    async SendChoice({ commit, getters }, data) {
      // console.log("-------- getQuestionInfo --------");
      commit("ToggleLoading");
      let api = {
        method: "post",
        url: `${process.env.VUE_APP_API_ORIGINAL}/surveyProcessing`,
        data: data,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async StartForm({ commit, getters }, data) {
      // console.log("-------- getQuestionInfo --------");
      commit("ToggleLoading");
      let api = {
        method: "post",
        url: `${process.env.VUE_APP_API}/webformProcessing`,
        data: data,
      };
      let response = await getters.SendAPIWithHeader(api);
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async backToStartForm({ commit, getters }, data) {
      // console.log("-------- getQuestionInfo --------");
      commit("ToggleLoading");
      let api = {
        method: "post",
        url: `${process.env.VUE_APP_API}/webformProcessing/backToStart`,
        data: data,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
    async backQuestion({ commit, getters }, data) {
      // console.log("-------- getQuestionInfo --------");
      commit("ToggleLoading");
      let api = {
        method: "post",
        url: `${process.env.VUE_APP_API}/webformProcessing/backQuestion`,
        data: data,
      };
      let response = await getters.SendAPIWithHeader(api);
      // console.log(response)
      let success = response.status === 200;
      commit("ToggleLoading");
      return new Promise((resolve, reject) => {
        return success ? resolve(response.data) : reject(response);
      });
    },
  },
  getters: {
    // request method
    SendAPIWithHeader: (state, getters) => async (api) => {
      let response = await axios({
        ...api,
        headers: {
          authorization:
            "Bearer " +
            cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token"),
        },
      }).catch((error) => {
        // console.log(error.response);
        state.loading = false;
        let routeName = router.currentRoute.name;
        if (routeName === "multiselect") {
          return error.response;
        } else if (routeName === "webform") {
          return error.response;
        } else if (routeName === "endwebform") {
          return error.response;
        } else if (routeName === "startform") {
          return error.response;
        } else if (routeName === "oneid_validate") {
          return error.response;
        } else {
          getters.ErrorHandling(error);
        }
        return error.response;
      });
      return response;
    },
    SendAPIWithHeaderNoValidateError: (state) => async (api) => {
      let response = await axios({
        ...api,
        headers: {
          authorization:
            "Bearer " +
            cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token"),
        },
      }).catch((error) => {
        // console.log(error.response)
        state.loading = false;
        return error.response;
      });
      return response;
    },
    SendAPIWithFormData: (state, getters) => async (api) => {
      let response = await axios({
        ...api,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).catch((error) => {
        // console.log(error.response);
        state.loading = false;
        getters.ErrorHandling(error);
        return error.response;
      });
      return response;
    },
    ErrorHandling: (state, getters) => (error) => {
      let text = error.response.data.message;
      if (!error.response.data.message) {
        text = `ระบบมีปัญหา<br><br>status: ${
          error.response.status
        }<br>error: ${JSON.stringify(
          error.response.data
        )}<br><br>สามารถติดต่อทีมงานได้ที่<br><a style="color: #0093cc;"
              href='tel:0935781416'
              >093-5781416</a
            >, <a style="color: #0093cc;"
            href='tel:0655214474'
            >065-5214474</a
          >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          >`;
      }
      if (!error.response) {
        state.loading = false;
        Swal.fire({
          html: `
          ระบบมีปัญหาเกี่ยวกับ server หรือ network ไม่สามารถใช้งานได้ชั่วคราว
          <br>ขออภัยในความไม่สะดวก
          <br><br>สามารถติดต่อทีมงานได้ที่<br><a style="color: #0093cc;"
              href='tel:0935781416'
              >093-5781416</a
            >, <a style="color: #0093cc;"
            href='tel:0655214474'
            >065-5214474</a
          >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          >`,
          icon: "error",
          showCancelButton: false,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          confirmButtonColor: "#0093cc",
          confirmButtonText: "รับทราบ",
        });
      } else {
        if (!error.response.data.auth) {
          if (error.response.data.message === "Token not match.") {
            Swal.fire({
              html: `พบการ login ซ้ำ`,
              icon: "warning",
              showCancelButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "ตกลง",
            });
            getters.ClearStageLogged();
          } else if (
            error.response.data.message === "Failed to authenticate token."
          ) {
            Swal.fire({
              html: `กรุณา login ใหม่`,
              icon: "warning",
              showCancelButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "ตกลง",
            });
            getters.ClearStageLogged();
          } else if (error.response.data.message === "Survey Not Avaliable.") {
            Swal.fire({
              html: `เกิดปัญหากับ survey ที่คุณเลือก กรุณาเลือก survey ใหม่อีกครั้ง`,
              icon: "warning",
              showCancelButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "รับทราบ",
            });
            state.loading = false;
            state.editing = false;
            state.editingPreData = null;
            state.editingConfirm = { edit: false };
            state.editingCurrent = null;
            router.push({
              name: "survey",
            });
          } else if (error.response.data.message === "Dont have package") {
            Swal.fire({
              html: `package ที่คุณใช้ไม่สามารถใช้งานได้<br>สอบถามข้อมูลเพิ่มเติมได้ที่<br><a style="color: #0093cc;"
              href='tel:0935781416'
              >093-5781416</a
            >, <a style="color: #0093cc;"
            href='tel:0655214474'
            >065-5214474</a
          >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          >`,
              icon: "warning",
              showCancelButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "รับทราบ",
            });
            getters.ClearStageLogged();
          } else if (
            error.response.data.message === "You are not authorized to try it."
          ) {
            Swal.fire({
              html: `คุณมี package เรียบร้อยแล้ว`,
              icon: "warning",
              showCancelButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "รับทราบ",
            }).then(() => {
              location.reload();
            });
          } else {
            Swal.fire({
              html: text,
              icon: "warning",
              showCancelButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "รับทราบ",
            });
            state.loading = false;
            return error.response;
          }
        }
      }
    },
    ClearStageLogged: (state) => () => {
      state.logged = false;
      state.loading = false;
      state.button_loading = false;
      state.expire = true;
      state.token = null;
      state.editing = false;
      state.editingPreData = null;
      state.editingConfirm = { edit: false };
      state.editingCurrent = null;
      state.surveylist = [];
      cookies.remove(process.env.VUE_APP_CM_AUTH_COOKIE + "_token");
      cookies.remove(process.env.VUE_APP_CM_AUTH_COOKIE + "_username");
      clearInterval(state.interval);
      state.interval = {};
    },
    FilterDataFromKey: () => (data) => {
      let masterData = data.masterData;
      let filter = data.filter;
      // console.log(masterData);
      // console.log(filter);
      for (const key in filter) {
        if (Object.hasOwnProperty.call(filter, key)) {
          const element = filter[key];
          let keyType = typeof element;
          if (key === "searchInput") {
            if (element.keyword) {
              masterData = masterData.filter((search) => {
                let insearch = element.search_criteria.find((k) => {
                  if (typeof search[k] === "string") {
                    if (
                      new RegExp(element.keyword.toUpperCase()).test(
                        search[k].toUpperCase()
                      )
                    ) {
                      return search[k];
                    }
                  } else if (typeof search[k] === "object") {
                    let longword = search[k].join(" ");
                    if (
                      new RegExp(element.keyword.toUpperCase()).test(
                        longword.toUpperCase()
                      )
                    ) {
                      return search[k];
                    }
                  }
                });
                if (insearch) {
                  return search;
                }
              });
            }
          } else {
            switch (keyType) {
              case "object":
                {
                  masterData = masterData.filter((check) => {
                    if (check[key]) {
                      let dataType = typeof check[key];
                      if (dataType === "string") {
                        if (
                          element.find((val) => {
                            if (typeof val === "string") {
                              if (val === check[key]) {
                                return val;
                              }
                            } else if (typeof val === "object") {
                              if (val[key]) {
                                if (val[key] === check[key]) {
                                  return val;
                                }
                              }
                            }
                          })
                        ) {
                          return check;
                        }
                      }
                    }
                  });
                }
                break;
              default:
                {
                  masterData = masterData.filter((check) => {
                    if (check[key]) {
                      let dataType = typeof check[key];
                      if (dataType === "string") {
                        if (
                          new RegExp(element.toUpperCase()).test(
                            check[key].toUpperCase()
                          )
                        ) {
                          return check;
                        }
                      } else if (dataType === "object") {
                        let longword = check[key].join(" ");
                        if (
                          new RegExp(element.toUpperCase()).test(
                            longword.toUpperCase()
                          )
                        ) {
                          return check;
                        }
                      }
                    }
                  });
                }
                break;
            }
          }
        }
      }
      // console.log(masterData);
      return masterData;
    },
    // rules
    UUID: () => () => {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    TextRule: () => (v) => {
      if (!v) {
        return "กรุณากรอกข้อมูล";
      }
      return true;
    },
    ButtonRule: () => (v) => {
      if (!v) {
        return "กรุณากรอกข้อมูล";
      } else if (_.toArray(v).length > 20) {
        return "กรุณาใส่ไม่เกินที่กำหนด";
      }
      return true;
    },
    URLRule: () => (v) => {
      if (
        !/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gm.test(
          v
        )
      ) {
        return `กรุณากรอก url ให้ถูกต้อง`;
      }
      return true;
    },
    ScoreRule: () => (v) => {
      if (!/^[+-]?\d{1,18}(\.\d{1,10})?$/.test(v)) {
        return `กรุณาใส่เฉพาะตัวเลข`;
      }
      return true;
    },
    PhoneRule: () => (v) => {
      if (v.length <= 0) {
        return "กรุณากรอกเบอร์โทรศัพท์";
      } else if (v.charAt(0) != "0" || v.charAt(1) === "0") {
        return "รูปแบบเบอร์โทรศัพท์ของคุณไม่ถูกต้อง";
      } else if (v.length != 10 && v.length != 9) {
        return "กรุณากรอกให้ครบ 9 หลัก หรือ 10 หลัก";
      } else if (!/^[0-9]+$/.test(v)) {
        return "กรุณากรอกข้อมูลเป็นตัวเลขเท่านั้น";
      }
      return true;
    },
    EmailRule: () => (v) => {
      if (!v) {
        return "กรุณากรอกข้อมูล";
      } else if (!/.+@.+\..+/.test(v)) {
        return `กรุณากรอก email ให้ถูกต้อง`;
      }
      return true;
    },
    NumberRule: () => (v) => {
      if (!/^-?(0|[1-9]\d*)(\.\d+)?$/.test(v)) {
        return `กรุณากรอกเป็นตัวเลขเท่านั้น`;
      }
      return true;
    },
    NumberRangeRule: () => (v) => {
      let amount = v.amount;
      let min = v.min;
      let max = v.max;
      if (
        !/^-?[0-9]+$/.test(amount) ||
        !/^-?[0-9]+$/.test(min) ||
        !/^-?[0-9]+$/.test(max)
      ) {
        return "กรุณากรอกเป็นจำนวนเต็มเท่านั้น";
      } else {
        if (amount < min) {
          return `กรุณากรอกมากกว่า ${v.min}`;
        } else if (amount > max) {
          return `กรุณากรอกน้อยกว่า ${v.max}`;
        }
      }

      // if (
      //   !/^\+?([0-9]\d*)$/.test(v.amount) ||
      //   !/^\+?([0-9]\d*)$/.test(v.min) ||
      //   !/^\+?([0-9]\d*)$/.test(v.max)
      // ) {
      //   return "กรุณากรอกเป็นตัวเลขเท่านั้น";
      // } else {
      //   if (v.amount === 0) {
      //     return v.min ? `กรุณากรอกมากกว่า ${v.min}` : true;
      //   } else if (v.amount < v.min) {
      //     return v.min ? `กรุณากรอกมากกว่า ${v.min}` : true;
      //   } else if (v.amount > v.max) {
      //     return v.max ? `กรุณากรอกน้อยกว่า ${v.max}` : true;
      //   }
      // }
      // if (
      //   !/^\+?([0-9]\d*)$/.test(v.amount) ||
      //   !/^\+?([0-9]\d*)$/.test(v.min) ||
      //   !/^\+?([0-9]\d*)$/.test(v.max)
      // ) {
      //   return "กรุณากรอกมากกว่า 0";
      // } else {
      //   if (v.min > v.max && v.max <= v.total) {
      //     return `กรุณากรอกน้อยกว่า ${v.max}`;
      //   } else if (v.min > v.max && v.max > v.total) {
      //     return `กรุณากรอกน้อยกว่า ${v.total}`;
      //   }
      // }
      return true;
    },
    // option
    DownloadImageFromURL: () => (fileUrl) => {
      var xhr = new XMLHttpRequest();
      xhr.responseType = "blob";
      xhr.onload = function () {
        var a = document.createElement("a"); // create html element anchor
        a.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
        a.download = `${Date.now()}.jpg`; // Set the file name.
        a.style.display = "none"; // set anchor as hidden
        document.body.appendChild(a);
        a.click();
        a.remove();
      };
      xhr.open("GET", fileUrl);
      xhr.send();
      return true;
    },
    CopyText: () => (text) => {
      // console.log(text);
      var input = document.createElement("textarea");
      input.innerHTML = text;
      document.body.appendChild(input);
      input.select();
      let copied = document.execCommand("copy");
      document.body.removeChild(input);
      return copied;
    },
    HourMinTime: () => (t) => {
      return `${t.split(":")[0]}:${t.split(":")[1]}`;
    },
    dateConvert: () => (d) => {
      var day = [
        "วันอาทิตย์",
        "วันจันทร์",
        "วันอังคาร",
        "วันพุธ",
        "วันพฤหัสบดี",
        "วันศุกร์",
        "วันเสาร์",
      ];
      var month = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];
      var date = new Date(d);
      var text =
        day[date.getDay()] +
        "ที่ " +
        date.getDate() +
        " " +
        month[date.getMonth()] +
        " " +
        (date.getFullYear() + 543);
      return text;
    },
    datetimeConvert: () => (d) => {
      var day = [
        "วันอาทิตย์",
        "วันจันทร์",
        "วันอังคาร",
        "วันพุธ",
        "วันพฤหัสบดี",
        "วันศุกร์",
        "วันเสาร์",
      ];
      var month = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];
      var date = new Date(d);
      let time =
        String(date.getHours()).padStart(2, "0") +
        ":" +
        String(date.getMinutes()).padStart(2, "0");
      var text =
        day[date.getDay()] +
        "ที่ " +
        date.getDate() +
        " " +
        month[date.getMonth()] +
        " " +
        (date.getFullYear() + 543);
      return text + " เวลา " + time + " น.";
    },
    dateConvertShort: () => (d) => {
      var month = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];
      var date = new Date(d);
      var text =
        date.getDate() +
        " " +
        month[date.getMonth()] +
        " " +
        (date.getFullYear() + 543);
      return text;
    },
    datetimeConvertShort: () => (d) => {
      var month = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ];
      var date = new Date(d);
      let time =
        String(date.getHours()).padStart(2, "0") +
        ":" +
        String(date.getMinutes()).padStart(2, "0");
      var text =
        date.getDate() +
        " " +
        month[date.getMonth()] +
        " " +
        (date.getFullYear() + 543);
      return text + " " + time + " น.";
    },
    dateConvertVeryShort: () => (d) => {
      var month = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ];
      var date = new Date(d);
      var text =
        date.getDate() +
        " " +
        month[date.getMonth()] +
        " " +
        (date.getFullYear() + 543 - 2500);
      return text;
    },
    datetimeISOString: () => (d) => {
      var date = new Date(d);
      let time =
        String(date.getHours()).padStart(2, "0") +
        ":" +
        String(date.getMinutes()).padStart(2, "0");
      var text =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) +
        "-" +
        date.getDate();
      return `${text}T${time}`;
    },
    DateDiffToday: () => (date) => {
      let day;
      let month;
      let year;

      let today = new Date();
      day = today.getDate();
      month =
        today.getMonth() + 1 < 10
          ? `0${today.getMonth() + 1}`
          : today.getMonth() + 1;
      year = today.getFullYear();
      let start = new Date(`${year}-${month}-${day}`);

      let datetodiff = new Date(date);
      day = datetodiff.getDate();
      month =
        datetodiff.getMonth() + 1 < 10
          ? `0${datetodiff.getMonth() + 1}`
          : datetodiff.getMonth() + 1;
      year = datetodiff.getFullYear();
      let end = new Date(`${year}-${month}-${day}`);

      var datediff =
        Math.ceil(start.getTime() / ((1000 * 60 * 60 + 7) * 24)) -
        Math.ceil(end.getTime() / ((1000 * 60 * 60 + 7) * 24)); //store the getTime diff - or +
      return datediff; //Convert values to -/+ days and return value
    },
  },
  modules: {},
});
